import axios from "axios";
export const loginCountTop10 = params => {
  return axios.request({
    url: "/api/log/unit/user/LoginCount",
    method: "get",
    params
  });
};
export const loginCountPage = params => {
  return axios.request({
    url: "/api/log/unit/user/page",
    method: "get",
    params
  });
};
export const loginCountPie = params => {
  return axios.request({
    url: "/api/log/unit/dept/LoginCount/pieChart",
    method: "get",
    params
  });
};
export const loginCountLine = params => {
  return axios.request({
    url: "/api/log/unit/dept/LoginCount/linePlot",
    method: "get",
    params
  });
};
// /api/audit/listAuditModuleEvents
export const listAuditModuleEvents = params => {
  return axios.request({
    url: "/api/audit/listAuditModuleEvents",
    method: "get",
    params
  });
};
// 导出单位应用的当天登录日志 /api/audit/exportUnitAppLoginLog
export const exportUnitAppLoginLog = params => {
  return axios.request({
    url: "/api/audit/exportUnitAppLoginLog",
    method: "get",
    params
  });
};
// 导出审计表单 /api/audit/exportAuditLog
export const exportAuditLog = data => {
  return axios.request({
    url: "/api/audit/exportAuditLog",
    method: "post",
    data
  });
};
export const exportAuditLogFile = data => {
  return axios.request({
    url: "/api/audit/exportAuditLog",
    method: "post",
    data,
    responseType: "blob",
    // 设置响应类型为 blob，用于处理二进制文件
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream" // 接受 Excel 文件格式
    }
  });
};
// https://test-iwork.ihotel.cn/version.html
export const version = () => {
  return axios.request({
    url: "/version.html",
    method: "get"
  });
};
// GET/api/gig/addressBook/searchMembersAsPlainList
export const searchMembersAsPlainList = params => {
  return axios.request({
    url: "/api/gig/addressBook/searchMembersAsPlainList",
    method: "get",
    params
  });
};